/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import advSearchState from 'Stores/advSearch';
import { observer } from 'mobx-react';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { DropDownBox } from '../shared-component/dropDownBox';

const originalDropDownValue = [
  {
    name: '$0 - 1M',
    pName: '$0 - 1M',
    selected: false,
  },
  {
    name: '$1 - 10M',
    pName: '$1 - 10M',
    selected: false,
  },
  {
    name: '$10 - 50M',
    pName: '$10 - 50M',
    selected: false,
  },
  {
    name: '$50 - 100M',
    pName: '$50 - 100M',
    selected: false,
  },
  {
    name: '$100 - 250M',
    pName: '$100 - 250M',
    selected: false,
  },
  {
    name: '$250 - 500M',
    pName: '$250 - 500M',
    selected: false,
  },
  {
    name: '$500M - 1B',
    pName: '$500M - 1B',
    selected: false,
  },
  {
    name: '> $1B',
    pName: '> $1B',
    selected: false,
  },
];
const Revenue = observer(props => {
  const suggestionKey = 'revenue';
  const blockedKey = 'revenue';
  const [showSuggestion, setShowSuggestion] = React.useState(false);
  const [suggestionList, setSuggestionList] = React.useState(
    originalDropDownValue,
  );
  // const [suggestionArr, setSuggestionArr] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [noMatchFound, setNoMatchFound] = React.useState(false);

  // const [searchKeys, setSearchKeys] = React.useState([]);

  React.useEffect(() => {
    // console.log('selectedItem ', selectedItem);
  }, [selectedItem]);
  // React.useEffect(() => {
  //   const arr = suggestionList.map(item => {
  //     return item.name;
  //   });
  //   console.log('suggestionArr ', arr);
  //   setSuggestionArr(arr);
  // }, []);
  return (
    <DropDownBox
      placeholder="Revenue"
      showSuggestion={showSuggestion}
      setShowSuggestion={setShowSuggestion}
      suggestionList={suggestionList}
      noMatchFound={noMatchFound}
      setNoMatchFound={setNoMatchFound}
      setSelectedItem={setSelectedItem}
      suggestionKey={suggestionKey}
      originalDropDownValue={originalDropDownValue}
      setSuggestionList={setSuggestionList}
      searchBoxId="revenueSearchBox"
      blockedKey={blockedKey}
      {...props}
    />
  );
});

export { Revenue };
export default Revenue;
